<template>
  <div class="money-container"></div>
</template>

<script>
  export default {
    name: 'money',
    mounted() {
      this.drawMoney();
    },
    methods: {
      drawMoney() {
        for (let i = 1; i < 30; i += 1) {
          const randomSpeed = (Math.random() * 0.8 + 0.7);
          const randomPosition = Math.random() * (window.innerWidth);
          const randomDelay = Math.random() * (0.1 + 0.6);

          const randomRotateX = Math.floor(Math.random() * 360);
          const randomRotateY = Math.floor(Math.random() * 360);

          const el = document.createElement('div');
          const elImg = document.createElement('div');

          el.appendChild(elImg);
          el.classList.add('money');

          el.style.left = `${randomPosition}px`;
          elImg.style.tansform = `rotateX(${randomRotateX}deg) rotateY(${randomRotateY}deg)`;

          if (this.getAnimMoneyReverse) {
            el.style.animation = `fallReverse ${randomSpeed}s linear`;
          } else {
            el.style.animation = `fall ${randomSpeed}s linear`;
          }

          el.style.animationDelay = `${randomDelay}s`;

          this.$el.appendChild(el);
        }
      },
    },
    computed: {
      getAnimMoneyReverse() {
        return this.$store.getters.getAnimMoneyReverse;
      },
    },
  };
</script>


<style lang="scss">
  .money-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    -webkit-transform-style: preserve-3d;
    -webkit-backface-visibility: hidden;
    -webkit-perspective: 1000;
    transform: translateZ(0);
  }

  .money {
    position: absolute;
    opacity: 0;
    -webkit-transform-style: preserve-3d;
    -webkit-backface-visibility: hidden;
    -webkit-perspective: 1000;

    div {
      width: 90px;
      height: 46px;
      background-image: url('http://transfertsdepekin.fr/assets/billet.png');
      background-size: cover;
    }
  }

  @keyframes fall {
    0% {
      transform: translateY(100vh) translateZ(0); opacity: 1;
    }
    50% {opacity: 0.8}
    100% {transform: translateY(-100%) translateZ(0); opacity:0;}
  }

  @keyframes fallReverse {
    0% {
      transform: translateY(-100%) translateZ(0); opacity: 0;
    }
    50% {opacity: 0.8}
    100% {transform: translateY(100vh) translateZ(0); opacity:1;}
  }
</style>



// WEBPACK FOOTER //
// Money.vue?00114dcc